<div class="response-container">
	<div class="titleContainer">
		<h2>Top Keywords</h2>
	</div>

	<div class="flex flex-col laptop:flex-row">
		<div class="w-full laptop:w-4/12 py-4 tablet:w-full desktop:pl-4 industrial:pl-4 mobile:px-4 tablet:px-4">
			<div class="table-container desktop:pl-4 industrial:pl-4 mobile:px-4 tablet:px-4">
				<table>
					<tbody>
						<tr *ngFor="let keyword of topKeyWords; let i = index" [ngClass]="{ 'alt-row': i % 2 === 0 }">
							<td>{{ keyword.phrase }}</td>
							<td class="count">{{ keyword.count }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="tablet:w-full laptop:w-8/12">
			<div id="wordCloudContainer"></div>
		</div>
	</div>
</div>
